import noticeSidebar from "@components/noticeSidebar/m2_noticeSidebar";
export default {
  components: {
    noticeSidebar
  },
  data: function () {
    return {
      user: {},
      testInforms: [],
      tipNoticeList: [],
      tipNoticeNum: 0,
      dialogVisible: false,
      tipDialogVisible: false,
      one_notice: {
        content: "",
        title: "",
        proc_id: ""
      },
      haveTip: false,
      this_notice: {
        content: "",
        title: "",
        proc_id: ""
      },
      pageIndex: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20, 50],
      total: 0,
      logoUrl: "",
      examName: "",
      domain: "",
      font_range: "",
      font_type: "",
      url_name: ""
    };
  },
  created: function () {
    this.getData();
    this.getExamData();
    this.$forceUpdate();
    this.$store.commit("setHeaderState", "21");
  },
  computed: {
    api_state: function () {
      return this.$store.state.examInfo.currentExamInfo.api_state;
    },
    user_type: function () {
      if (this.$store.state.common.userType != null) {
        if (
          this.$store.state.common.userType.if_bind_user &&
          this.$store.state.common.token != null
        ) {
          this.getNoReadTipAnnouncement();
        }
        if (
          this.$store.state.common.userType.if_bind_user &&
          this.$store.state.common.currentUser == null
        ) {
          this.$http.get(globalProvider.serviceUrl("pc/g")).then(data => {
            if (data.body.code == resultCode.Success) {
              this.$store.commit("setCurrentUser", data.body.data);
            }
          });
        }
      }
      return this.$store.state.common.userType;
    }
  },
  watch: {
    api_state: function (curVal, oldVal) {
      if (this.$store.state.examInfo.currentExamInfo.api_state) {
        this.getData();
      }
    },
    tipNoticeNum(curVal, oldVal) {
      this.getAnnouncement(this.tipNoticeList[curVal], "tip");
    }
  },
  methods: {
    getExamData: function () {
      if (this.$route.name === "main"||this.$route.name === "batch_main") {
        // var setCurrentExamInfo = {
        //   api_state: false
        // };
        // this.$store.commit("setCurrentExamInfo", setCurrentExamInfo);
        this.getInfo();
      } else {
        let currentExamInfo = this.$store.state.examInfo.currentExamInfo;
        this.logoUrl = currentExamInfo.logo_name;
        this.examName = currentExamInfo.exam_name;
        this.font_type = currentExamInfo.font_type;
        this.font_range = currentExamInfo.font_range;
        this.exam_type = currentExamInfo.exam_type;
        this.domain = currentExamInfo.domain;
        this.excuseExam = currentExamInfo.exempt_exam_is_open;
        if (currentExamInfo.url_name != null) {
          this.url_name = "http://" + currentExamInfo.url_name;
        } else {
          this.url_name = "#/e/" + currentExamInfo.domain + "/login";
        }
      }
    },
    getInfo: function () {
      
      this.$http
        .get(globalProvider.serviceUrl("exm_c/g/eis/{domain}"), {
          params: {
            domain: this.$route.params.projectCode,
            loading: true
          }
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            data.body.data.api_state = true;
            this.$store.commit("setCurrentExamInfo", data.body.data);
            this.logoUrl = data.body.data.logo_name;
            this.examName = data.body.data.exam_name;
            this.exam_type = data.body.data.exam_type;
            this.domain = data.body.data.domain;
            this.font_type = data.body.data.font_type;
            this.font_range = data.body.data.font_range;
            this.excuseExam = data.body.data.exempt_exam_is_open;
            if (data.body.data.url_name != null) {
              this.url_name = "http://" + data.body.data.url_name;
            } else {
              this.url_name = "#/e/" + data.body.data.domain + "/login";
            }
          } else this.$router.push({
            name: "default.notFound"
          });
        });
    },
    pageIndexChange: function (pageIndex) {
      this.pageIndex = pageIndex;
      this.getData();
    },
    sizeChange: function (pageSize) {
      this.pageSize = pageSize;
      if (this.pageIndex === 1) {
        this.getData();
      } else {
        this.pageIndex = 1;
        this.getData();
      }
    },
    getNormalAnn: function (captcha_token) {
      let url;
      if( this.$store.state.examInfo.currentExamInfo.batchCode){
          url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/BATCH/'+this.$store.state.examInfo.currentExamInfo.batchCode;
      }else{
          url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/PROJECT';
      }
      this.$http
        .get(
          globalProvider.serviceUrl(
           url
          ), {
            params: {
              domain: this.$store.state.examInfo.currentExamInfo.domain,
              page_index: this.pageIndex,
              page_size: this.pageSize,
              n_type: "se"
            },
            headers: {
              ttoken: captcha_token
            },
            emulateJSON: false
          }
        )
        .then(data => {
          if (data.body.code == resultCode.Success) {
            data.body.data.map(item => {
              if (item.type == 1) {
                this.testInforms = item._items;
                this.total = item.totalCount;
                this.pageIndex = item.pageIndex;
              }
            });
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message), "提示", {
              confirmButtonText: "确定"
            });
          }
        });
    },
    set_captcha_token: function (callback) {
      this.$http.get(globalProvider.serviceUrl("ea/tt")).then(data => {
        if (data.body.code == resultCode.Success) {
          callback(data.body.data);
        }
      });
    },
    // getTipAnnouncement: function (captcha_token) {
    //   let url;
    //   if( this.$store.state.examInfo.currentExamInfo.batchCode){
    //       url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/BATCH/'+this.$store.state.examInfo.currentExamInfo.batchCode;
    //   }else{
    //       url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/PROJECT';
    //   }
    //   this.$http
    //     .get(globalProvider.serviceUrl("ea/g/tnis/{domain}/se"), {
    //       params: {
    //         domain: this.$store.state.examInfo.currentExamInfo.domain
    //       },
    //       headers: {
    //         ttoken: captcha_token
    //       },
    //       emulateJSON: false
    //     })
    //     .then(data => {
    //       if (data.body.code == resultCode.Success) {
    //         if (data.body.data.length > 0) {
    //           this.tipNoticeList = data.body.data;
    //           this.tipDialogVisible = true;
    //           this.getAnnouncement(this.tipNoticeList[0]);
    //         }
    //       } else if (data.body.code == resultCode.NotSuccess) {
    //         this.$alert(getErrorMessage(data.body.message), "提示", {
    //           confirmButtonText: "确定"
    //         });
    //       }
    //     });
    // },
    getNoReadTipAnnouncement: function () {
      if (!this.haveTip) {
        this.$http.get(globalProvider.serviceUrl("ea/g/utnis")).then(data => {
          if (data.body.code == resultCode.Success) {
            if (data.body.data.length > 0) {
              this.tipNoticeList = data.body.data;
              this.haveTip = true;
              this.tipDialogVisible = true;
              this.getAnnouncement(this.tipNoticeList[0]);
            }
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message), "提示", {
              confirmButtonText: "确定"
            });
          }
        });
      }
    },
    getAnnouncement: function (notice_id, id) {
      if (id === "normal") {
        document.getElementsByClassName("notice-dialog-body").scrollTop = 0;
        this.dialogVisible = true;
        this.$http
          .get(globalProvider.serviceUrl("ea/g/nts/d/{notice_id}"), {
            params: {
              notice_id: notice_id
            }
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              this.one_notice = data.body.data;
            } else if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message), "提示", {
                confirmButtonText: "确定"
              });
            }
          });
      } else {
        this.$http
          .get(globalProvider.serviceUrl("ea/g/nts/d/{notice_id}"), {
            params: {
              notice_id: notice_id
            }
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              this.this_notice = data.body.data;
            } else if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message), "提示", {
                confirmButtonText: "确定"
              });
            }
          });
      }
    },
    getData() {
      this.getNormalAnn();
    }
  }
};